import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { getPageLinkByNodeId } from "@insite/client-framework/Store/Links/LinksSelectors";
import LinksState from "@insite/client-framework/Store/Links/LinksState";
import translate from "@insite/client-framework/Translate";
import Breadcrumbs, { BreadcrumbsPresentationProps } from "@insite/mobius/Breadcrumbs";
import { LinkProps } from "@insite/mobius/Link";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import UCSColors from "@ucs/Utils/UCSColors";
import React, { FC } from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationState) => {
    return {
        links: state.components.breadcrumbs.links,
        linksState: state.links,
        nodeId: getCurrentPage(state).nodeId,
    };
};

interface OwnProps {
    theme?: THEMES;
    productCategory: any;
}

export interface PageBreadcrumbsStyles {
    breadcrumbs?: BreadcrumbsPresentationProps;
}

export enum THEMES {
    DARK = 1,
    LIGHT = 2,
    GRAY = 3,
}

export const pageBreadcrumbStyles: PageBreadcrumbsStyles = {};

type Props = OwnProps & ReturnType<typeof mapStateToProps>;

const homePageLink = { children: translate("Home"), href: "/" };

const ProductDetailPageBreadcrumbs: FC<Props> = (props: Props) => {
    const alternateLinks = [] as LinkProps[];
    const catalogHref = `${translate("Catalog_UrlRoot")}`;
    if (props.links && props.links.length > 1) {
        if (props.links[1].children === "Application" && !props.productCategory.applicationOriginated) {
            alternateLinks.push(
                {
                    children: "Home",
                    href: "/",
                },
                {
                    children: "Type",
                    href: `/${catalogHref}/type`,
                },
                {
                    children: props.productCategory.l2,
                    href: `/${catalogHref}/products/${props.productCategory.l2UrlSegment}`,
                },
                {
                    children: "redundant",
                    href: "google.com",
                },
            );
        }
    }
    let links = props.links || generateLinksFrom(props.linksState, props.nodeId);
    if (alternateLinks.length > 0) {
        links = alternateLinks;
    }
    if (links.length > 0 && links[0].href !== homePageLink.href) {
        links = [homePageLink, ...links];
    }

    const themes: { [key in THEMES]?: string } = {
        [THEMES.DARK]: "black",
        [THEMES.LIGHT]: "white",
        [THEMES.GRAY]: UCSColors.gray03,
    };

    const customProps: TypographyPresentationProps = {
        color: themes[props.theme || THEMES.LIGHT],
        size: 14,
        css: css`
            padding-top: 4px;
            color: ${themes[props.theme || THEMES.LIGHT]} !important;
        `,
    };

    const themedPropss: TypographyPresentationProps = {
        ...pageBreadcrumbStyles.breadcrumbs,
        css: css`
            padding-top: 4px;
        `,
    };

    return (
        <Breadcrumbs
            links={links}
            data-test-selector="pageBreadcrumbs"
            typographyProps={props.theme ? customProps : themedPropss}
        />
    );
};

export function generateLinksFrom(linksState: LinksState, nodeId: string) {
    const links: LinkProps[] = [];
    let currentLink = getPageLinkByNodeId({ links: linksState }, nodeId);
    while (currentLink) {
        if (currentLink.type === "HomePage") {
            links.unshift(homePageLink);
        } else {
            links.unshift({ children: currentLink.title, href: currentLink.url });
        }
        currentLink = currentLink.parentId
            ? getPageLinkByNodeId({ links: linksState }, currentLink.parentId)
            : undefined;
    }
    return links;
}

export default connect(mapStateToProps)(ProductDetailPageBreadcrumbs);
